<script>
import SelectIdentity from "$vueCommon/components/Select/SelectIdentity.vue";
import IdentityAddEdit from "$vueCommon/components/Cart/IdentityAddEdit.vue";

export default {
    emits: ['onSelected', 'onEdited'],
    components: {
        SelectIdentity,
        IdentityAddEdit
    },
    props: {
        identities: Array,
        selected: Object,
        saving: Boolean,
        errors: Array
    },
    data() {
        return {
            firstBillingIdentity: this.selected || {},
            forceFirstAdd: false
        }
    },
    mounted() {
        if (!this.hasFilledAccount()) {
            this.forceFirstAdd = true;
        }
    },
    methods: {
        onSelected(identity) {
            this.$emit('onSelected', identity);
        },
        onEdited(identityId) {
            this.$emit('onEdited', identityId);
        },
        hasFilledAccount() {
            if (!this.identities || !this.identities.length) {
                return false;
            }

            const required = [
                'first_name',
                'last_name',
                'address',
                'district',
                'postal_code',
                'city',
                'phone',
                'email',
            ];

            return this.identities.some(identity => {
                if (!identity.country_id) {
                    return false;
                }

                for (const field of required) {
                    const value = identity[field];

                    if (!value || value.toString().trim() === '') {
                        return false;
                    }
                }

                return true;
            });
        },
        onFirstIdentitySaved(identityId) {
            this.$emit('onEdited', identityId);
        },
        onFirstIdentityDismiss() {},
        async validateAndSaveForPayNow() {
            if (this.forceFirstAdd) {
                const form = this.$refs.firstIdentityForm;
                if (form && typeof form.saveForPayNow === 'function') {
                    return await form.saveForPayNow();
                }

                return false;
            }

            if (this.hasFilledAccount()) {
                return true;
            }

            return false;
        }
    }
}
</script>

<template>
    <div class="mb-3 component-billing-data">
        <h2 class="h4" v-if="!hasFilledAccount() || forceFirstAdd">{{ $translate('checkout.your_first_address') }}</h2>
        <h2 class="h4" v-if="!(!hasFilledAccount() || forceFirstAdd)">{{ $translate('checkout.billing_data') }}</h2>

        <div v-if="hasFilledAccount() && !forceFirstAdd">
            <div :class="{'is-invalid': errors && errors.length > 0}">
                <SelectIdentity
                    :identities="identities"
                    :selected="selected"
                    :buttonAddText="$translate('checkout.add_new_address')"
                    :saving="saving"
                    identityType="billing"
                    @onEdited="onEdited"
                    @onSelected="onSelected"
                />
            </div>
            <div class="invalid-feedback" v-if="errors && errors.length">
                <small v-for="error in errors" :key="error" v-html="error"></small>
            </div>
        </div>
        <div v-else>
            <IdentityAddEdit
                ref="firstIdentityForm"
                :identity="firstBillingIdentity"
                :onConfirm="onFirstIdentitySaved"
                :onDismiss="onFirstIdentityDismiss"
                identityType="billing"
                actionType="firstAdd"
            />
            <!--
            <div class="invalid-feedback d-block" v-if="errors && errors.length">
                <small v-for="error in errors" :key="error" v-html="error"></small>
            </div>
            -->
        </div>
    </div>
</template>
